import { Task } from './task.interface';

export interface CreateDefaultChecklistDto {
    name: Record<string, string>;
    tasks: Task[];
    flis: string[];
}
